package io.horion.cv.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page

@Page("about")
@Composable
fun About() {}